/** CTA 前进箭头：2px 描边 + 圆角端点，适配深色按钮上的 `currentColor` */
export function EnterWorkspaceIcon({ className = 'w-[15px] h-[15px] flex-shrink-0' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path
        d="M2.5 8h8M9 5l3.5 3L9 11"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
